import React from "react";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import { useCheckoutContext, } from "../../../context/useCheckoutContext";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
import { PaymentTypeEnum } from "../../../shared/constants/PaymentTypeEnum";
var useStyle = makeStyles({
    gridContainer: {
        marginBottom: "100px",
        marginTop: "24px",
    },
    textTree: {
        color: "#677784",
    },
});
export var OtpInvalidTries = function () {
    var classes = useStyle();
    var _a = useCheckoutContext(), handlers = _a.handlers, paymentType = _a.paymentType;
    var handleClick = function () {
        var _a;
        var configSections = (_a = {},
            _a[PaymentTypeEnum.SUBSCRIPTION] = configCardSections.subscription,
            _a[PaymentTypeEnum.UNIQUE] = configCardSections.card,
            _a[PaymentTypeEnum.MIXED] = configCardSections.card,
            _a);
        handlers.setCheckoutSection(configSections[paymentType]);
    };
    return (React.createElement(Grid, { container: true, spacing: 4, justify: "center", alignItems: "center", direction: "column", className: classes.gridContainer },
        React.createElement(Grid, { item: true, xs: 11, md: 9 },
            React.createElement(Typography, { variant: "h5", align: "center", color: "primary" },
                React.createElement(T, { id: "otpInvalidTries.partOneText" }))),
        React.createElement(Grid, { item: true, xs: 11, md: 9 },
            React.createElement(Typography, { variant: "body1", align: "left" },
                React.createElement(T, { id: "otpInvalidTries.partTwoText" })),
            React.createElement(Box, { marginY: 1 },
                React.createElement(Typography, { variant: "body2", align: "left", className: classes.textTree },
                    React.createElement(T, { id: "otpInvalidTries.partTreeText" })))),
        React.createElement(Grid, { item: true, xs: 11, md: 9 },
            React.createElement(Typography, { variant: "body1", align: "center", color: "primary", onClick: handleClick },
                React.createElement(T, { id: "otpInvalidTries.partFourText" })))));
};
export default OtpInvalidTries;
